import { TranslationMap } from '@trimble-gcs/i18n-types';

export function scandataTreeMenuTranslations() {
  return {
    showDetails: {
      text: $localize`:@@scandataTreeMenu.showDetails:Show Details`,
      desc: 'Popup Menu item text to display the details for the scan in the Scan tree view.',
    },
    fitToView: {
      text: $localize`:@@scandataTreeMenu.fitToView:Fit to View`,
      desc: "Popup Menu item text to fit all scans into the camera's view.",
    },
    rotatePanoramas: {
      text: $localize`:@@scandataTreeMenu.rotatePanoramas:Rotate Panoramas`,
      desc: 'Popup Menu item text to rotate the panorama views of the scan for specific coordinate systems.',
    },
    viewInNumark: {
      text: $localize`:@@scandataTreeMenu.viewInNumark:View in Multi-pane`,
      desc:
        'Popup Menu item text to open the selected item in Numark. ' +
        "The term 'Multi-pane' is a brand name and not translated.",
    },
  } satisfies TranslationMap;
}
